//use this when creating a DOM parser is not an option...
export const stripHtmlStrings = (str) => {
    if (!str || str === ``) return false;
    else str = str.toString();
    return str.replace(/(<([^>]+)>)/gi, ``).trim();
};
